export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Slovenčina'
  },
  'title': 'STIAHNUTIE PRODUKTU Z PREDAJA: EXPRESKY ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Stiahnutie produktu z predaja. Dôležité informácie týkajúce sa vašej bezpečnosti a vybavenia.',
    'purchaseWindow': 'Zakúpili ste si lezeckú expresku ALPINISM a/alebo VERTIKA v období od 1. januára 2022 do 23. júla 2026.',
    'skus': 'Expreska Alpinism 11 cm (4051175 / 8589547)\nExpreska Alpinism 17 cm (4051176 / 8589548)\nSúprava 5 ks expresiek Alpinism (4171656 / 8608405)\nExpreska Vertika 11 cm (5499689 / 8935765)\nExpreska Vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'Výroba a vývoj osobných ochranných prostriedkov so sebou nesú absolútnu zodpovednosť voči tým, ktorí naše produkty používajú. Z tohto dôvodu vás informujeme o stiahnutí z predaja, ktoré sa týka expresiek vybavených karabínou Rocky Fil.',
    'defect': 'Pri niektorých karabínach sme identifikovali chybu v nitovaní drôteného zámku. Táto chyba pri montáži môže spôsobiť jeho zlomenie a v prípade pádu predstavuje riziko prasknutia celej karabíny.',
    'stopUsing': 'Z preventívnych dôvodov vás žiadame, aby ste svoj produkt okamžite prestali používať a postupovali podľa nižšie uvedených pokynov.'
  },
  'procedure': {
    'stopUsing': 'Žiadame vás preto, aby ste tento produkt okamžite prestali používať a podľa nižšie uvedených kontrolných pokynov zistili, či sa táto chyba týka aj vášho produktu.',
    'title': 'Ako skontrolovať váš produkt:',
    'intro': 'Skontrolujte, či sú obe strany drôteného zámku pevne pripevnené ku karabíne:',
    'step1': 'Uchopte karabínu na jednej strane, vložte palec medzi dva drôty (tak, aby bol najbližšie k nitu) a pevne zatlačte smerom nadol ku karabíne.',
    'step2': 'Otočte karabínu a zopakujte rovnaký postup na druhej strane drôteného zámku.'
  },
  'outcome': {
    'nok': {
      'body': 'Ak sa po kontrole drôt uvoľnil: Okamžite prestaňte váš produkt používať a vráťte ho do najbližšej predajne DECATHLON. Náš tím sa postará o váš chybný produkt a na mieste vám v plnej výške vráti peniaze.',
      'support': 'Ak máte v súvislosti so stiahnutím produktu špecifické otázky, radi s vami nájdeme riešenie na mieru. Zavolajte nám na +421 2 772 77 490 od pondelka do piatku (9:00 – 18:00) alebo v sobotu (9:00 – 17:00).'
    },
    'ok': {
      'body': 'Ak drôt po kontrole zo zámku nevyšiel, toto stiahnutie z predaja sa vášho produktu netýka a môžete ho naďalej úplne bezpečne používať.'
    }
  },
  'buttons': {
    'ok': 'Môj produkt JE v poriadku',
    'nok': 'Môj produkt NIE JE v poriadku'
  }
} as const
